import React, { useState, useEffect, useRef } from 'react';
import { Link } from "react-router-dom";
import { Button, Badge } from "react-bootstrap";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import swal from "sweetalert2";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import bgimage from '../../../../images/items/items.jpg';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import DatePicker, { DateObject } from "react-multi-date-picker";
import AddItem from './../../../modal/Production_Management/Manage_Items/AddItem';
import EditItem from './../../../modal/Production_Management/Manage_Items/EditItem';
import AddRawMaterial from './../../../modal/Production_Management/Manage_Items/AddRawMaterial';
import AddReceipeNotes from './../../../modal/Production_Management/Manage_Items/AddReceipeNotes';
import UpdateRawMaterial from './../../../modal/Production_Management/Manage_Items/UpdateRawMaterial';
import { Row, Col, Tab, Nav, Dropdown } from "react-bootstrap";
import axios from 'axios'; // new
import AddChecklist from './../../../modal/Production_Management/Manage_Items/AddChecklist';
import ItemStaging from './../../../modal/Production_Management/Manage_Items/AddItemStaging';
import AddItemStaging from './../../../modal/Production_Management/Manage_Items/AddItemStaging';
import ItemStagingView from './../../../modal/Production_Management/Manage_Items/ViewItemStaging';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const Items = () => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const tableRef = useRef(null);
    const onInit = () => {
        //   console.log('lightGallery has been initialized'); 
    };

    const [key, setKey] = useState('item_list');
    const handleModalToggleAdd = () => {
        setModalType("AddItem");
        setOpen(true);
    };

    const handleModalToggleEdit = () => {
        setModalType("EditItem");
        setOpen(true);
    };

    const [selectedItem, setSelectedItem] = useState(null);
    const handleModalToggle_Edit = (item) => {
        axios.get(`${baseURL}/manage-items/${item.sno}`)
            .then(response => {
                setSelectedItem(response.data.data); // Set full item details to modal
                setModalType("EditItem");
                setOpen(true);
            })
            .catch(error => {
                console.error("Failed to fetch package for edit:", error);
            });
    };

    const [selectedOption, setSelectedOption] = useState(null);
    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);

    const [filterOpen, setFilterOpen] = useState(false);
    const onClose = () => {
        setFilterOpen(false);
    };

    const DeleteModal = (itemId, itemName, onDeleted) => { // change 
        swal.fire({
            html: `
                <div class="alert alert-danger px-2 py-2" role="alert">
                    <strong>OOPS! </strong> You're about to lose one Products
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <p class="text-center"><b>${itemName}</b></p>  
                <div class="text-center">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48">
                        <defs>
                            <radialGradient id="radial-gradient" cx="-27.957" cy="8.563" r="6" gradientTransform="matrix(3 0 0 2.5 107.871 -4.408)" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#5987dd"/>
                                <stop offset=".118" stop-color="#638bd6"/>
                                <stop offset=".316" stop-color="#7d98c3"/>
                                <stop offset=".572" stop-color="#a8aba3"/>
                                <stop offset=".871" stop-color="#e3c678"/>
                                <stop offset="1" stop-color="#ffd364"/>
                            </radialGradient>
                            <style>.cls-3{fill:#ffb32b}.cls-4{fill:#273941}.cls-5{fill:#141e21}.cls-6{fill:#f6fafd}</style>
                        </defs>
                        <g id="_27-feel_bad" data-name="27-feel bad">
                            <circle cx="24" cy="24" r="23" style="fill:#ffce52"/>
                            <ellipse cx="24" cy="17" rx="18" ry="15" style="fill:url(#radial-gradient)"/>
                            <path class="cls-3" d="M46 23c0 10.493-9.85 19-22 19S2 33.493 2 23h-.975c-.014.332-.025.665-.025 1a23 23 0 0 0 46 0c0-.335-.011-.668-.025-1z"/>
                            <ellipse class="cls-4" cx="33" cy="23" rx="3" ry="4"/>
                            <ellipse class="cls-5" cx="33" cy="23" rx="2" ry="3"/>
                            <circle class="cls-6" cx="34" cy="22" r="1"/>
                            <ellipse class="cls-4" cx="15" cy="23" rx="3" ry="4"/>
                            <ellipse class="cls-5" cx="15" cy="23" rx="2" ry="3"/>
                            <circle class="cls-6" cx="16" cy="22" r="1"/>
                            <path class="cls-5" d="M10 19v-2c3.722 0 6-1.295 6-2h2c0 2.626-4.024 4-8 4zM38 19c-3.976 0-8-1.374-8-4h2c0 .705 2.278 2 6 2z"/>
                            <path class="cls-4" d="M24 35h-5.5a5.265 5.265 0 0 1 5.5-5 5.265 5.265 0 0 1 5.5 5z"/>
                            <path class="cls-5" d="M24 31a5.4 5.4 0 0 1 5.39 4h.11a5.265 5.265 0 0 0-5.5-5 5.265 5.265 0 0 0-5.5 5h.11A5.4 5.4 0 0 1 24 31z"/>
                            <path d="M47 12a4 4 0 0 1-8 0c0-2.209 3-8 4-8s4 5.791 4 8z" style="fill:#3bc5f6"/>
                            <path d="M43 4c-1 0-4 5.791-4 8a4 4 0 0 0 8 0c0-2.209-3-8-4-8zm0 8.5a2.848 2.848 0 0 1-3-2.667C40 8.361 42.25 4.5 43 4.5s3 3.861 3 5.333a2.848 2.848 0 0 1-3 2.667z" style="fill:#00a3e1"/>
                            <path class="cls-3" d="M43 16a3.991 3.991 0 0 1-3.861-3.008A4.661 4.661 0 0 0 39 14a4 4 0 0 0 6.846 2.807q-.255-.777-.562-1.529A3.982 3.982 0 0 1 43 16z"/>
                            <ellipse class="cls-6" cx="44" cy="11" rx=".825" ry="1.148" transform="rotate(-45.02 44 11)"/>
                            <ellipse class="cls-6" cx="44.746" cy="9.5" rx=".413" ry=".574" transform="rotate(-45.02 44.746 9.5)"/>
                            <ellipse class="cls-6" cx="36" cy="9" rx=".825" ry="1.148" transform="rotate(-45.02 36 9)"/>
                            <ellipse class="cls-6" cx="29.746" cy="4.5" rx=".413" ry=".574" transform="rotate(-45.02 29.746 4.5)"/>
                            <ellipse class="cls-6" cx="33" cy="7" rx="1.65" ry="2.297" transform="rotate(-45.02 33 7)"/>
                        </g>
                    </svg>
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, Cancel',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-danger',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            if (result.isConfirmed) { // change 
                axios.delete(`${baseURL}/manage-items/${itemId}`) // change 
                    .then(() => {
                        swal.fire({
                            title: 'Item Deleted!',
                            text: itemName,
                            icon: 'success',
                            showCancelButton: false,
                            confirmButtonText: 'OK',
                            customClass: {
                                title: 'fs-6',
                                confirmButton: 'btn btn-sm btn-primary',
                            },
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        }); // change 
                        if (onDeleted) onDeleted(); // Refresh the list or update UI // change 

                    })
                    .catch(error => {
                        console.error("Deletion failed:", error);
                        swal.fire({
                            title: 'Error!',
                            text: `Failed to delete ${itemName}`,
                            icon: 'error',
                            confirmButtonText: 'OK',
                            customClass: {
                                title: 'fs-6',
                                confirmButton: 'btn btn-sm btn-danger',
                            },
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        });
                    });
            } else {
                swal.fire({
                    title: 'Delete Process Cancelled',
                    text: itemName, // change 
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonText: 'OK',
                    customClass: {
                        title: 'fs-6',
                        confirmButton: 'btn btn-sm btn-primary',
                    },
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                });
            }
        });
    };

    const [items, setItems] = useState([]);
    const [itemCount, setItemCount] = useState(0);
    const [hasFetched, setHasFetched] = useState(false);
    const [page, setPage] = useState(1); //pagination
    const [totalPages, setTotalPages] = useState(1); //pagination
    const [searchTerm, setSearchTerm] = useState(''); //pagination
    const [perPage, setPerPage] = useState(25); //pagination

    const fetchData = async (pageNumber = page, perPageCount = perPage, search = searchTerm) => {
        setHasFetched(false);
        try {
            const response = await axios.get(`${baseURL}/manage-items`, {
                params: {
                    page: pageNumber,
                    per_page: perPageCount,
                    search: search,
                }
            });

            const data = response.data;
            setItems(data.data || []);
            setItemCount(data.pagination?.total || 0);
            setTotalPages(data.pagination?.last_page || 1);
            setHasFetched(true);
        } catch (error) {
            console.error('Error fetching items:', error);
            setHasFetched(true);
            setItems([]);
            setItemCount(0);
        }
    };

    // Refresh method (like softRefresh)
    const softRefresh = () => {
        setHasFetched(false);
        fetchData(1, perPage, searchTerm); // reset to page 1
    };

    // Fetch when page, perPage, or search changes
    useEffect(() => {
        fetchData(page, perPage, searchTerm);
    }, [page, perPage, searchTerm]);

    // Initialize DataTable when the data is fetched
    useEffect(() => {
        if (hasFetched) {
            if (tableRef.current && !$.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable({
                    destroy: true,
                    responsive: true,
                    pageLength: 25,
                    ordering: false,
                    language: {
                        "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                    },
                    dom:
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        }
    }, [hasFetched]);

    const [itemcategoryCount, setItemCategoryCount] = useState(0); // used for item category count
    const [itemsubcategoryCount, setItemSubCategoryCount] = useState(0);  // used for item sub category data
    const [itemScheduleCount, setItemScheduleCount] = useState(0);

    useEffect(() => {
        axios.get(`${baseURL}/item-categories`)
            .then(response => {
                const data = response.data;

                // Check if the response contains product categories correctly
                if (Array.isArray(data)) {
                    // setProductCategories(data);  // Set the product categories list
                    setItemCategoryCount(data.length);  // Set category count based on the array length
                } else if (Array.isArray(data?.data)) {
                    // setProductCategories(data.data);  // Set product categories if nested in 'data'
                    setItemCategoryCount(data.data.length);  // Set category count based on the nested array
                } else {
                    console.warn("Unexpected response format for categories:", data);
                    // setProductCategories([]);  // Default to an empty list
                    setItemCategoryCount(0);  // Default to 0 in case of unexpected response
                }
            })
            .catch(error => {
                console.error("Error fetching item categories:", error);
                // setProductCategories([]);  // Default to an empty list in case of error
                setItemCategoryCount(0);  // Default to 0 in case of error
            });
    }, []);  // Only run once on mount

    useEffect(() => {
        axios.get(`${baseURL}/item-subcategories`)
            .then(response => {
                const data = response.data;

                // Check if the response contains product categories correctly
                if (Array.isArray(data)) {
                    // setProductCategories(data);  // Set the product categories list
                    setItemSubCategoryCount(data.length);  // Set category count based on the array length
                } else if (Array.isArray(data?.data)) {
                    // setProductCategories(data.data);  // Set product categories if nested in 'data'
                    setItemSubCategoryCount(data.data.length);  // Set category count based on the nested array
                } else {
                    console.warn("Unexpected response format for categories:", data);
                    // setProductCategories([]);  // Default to an empty list
                    setItemSubCategoryCount(0);  // Default to 0 in case of unexpected response
                }
            })
            .catch(error => {
                console.error("Error fetching item sub categories:", error);
                // setProductCategories([]);  // Default to an empty list in case of error
                setItemSubCategoryCount(0);  // Default to 0 in case of error
            });
    }, []);  // Only run once on mount

    useEffect(() => {
        axios.get(`${baseURL}/item-schedule`)
            .then(response => {
                const data = response.data;

                // Check if the response contains product categories correctly
                if (Array.isArray(data)) {
                    // setProductCategories(data);  // Set the product categories list
                    setItemScheduleCount(data.length);  // Set category count based on the array length
                } else if (Array.isArray(data?.data)) {
                    // setProductCategories(data.data);  // Set product categories if nested in 'data'
                    setItemScheduleCount(data.data.length);  // Set category count based on the nested array
                } else {
                    console.warn("Unexpected response format for schedule:", data);
                    // setProductCategories([]);  // Default to an empty list
                    setItemScheduleCount(0);  // Default to 0 in case of unexpected response
                }
            })
            .catch(error => {
                console.error("Error fetching item schedule:", error);
                // setProductCategories([]);  // Default to an empty list in case of error
                setItemScheduleCount(0);  // Default to 0 in case of error
            });
    }, []);  // Only run once on mount

    // used for status change
    const handleProductStatusChange = (itemId, currentStatus) => {
        const newStatus = currentStatus === 0 ? 1 : 0;

        axios.post(`${baseURL}/manage-items/status/${itemId}`, { status: newStatus })
            .then(() => {
                // Re-fetch products after status update
                fetchData();
            })
            .catch(error => {
                console.error("Error updating product status:", error);
            });
    };

    // For View(Start)
    const [viewItemDetails, setViewItemDetails] = useState(null);
    const handleModalToggle = (itemId) => {
        axios.get(`${baseURL}/manage-items/${itemId}`)
            .then(response => {
                setViewItemDetails(response.data);
                setModalType("View");
                setOpen(true);
            })
            .catch(error => {
                console.error("Error fetching product details:", error);
            });
    };

    // For View(End)
    // For Raw Material View(Start)
    const [viewRawMaterialItemDetails, setViewRawMaterialItemDetails] = useState(null);
    const handleModalToggleRawMaterial = (itemId) => {
        axios.get(`${baseURL}/manage-items/raw-materials/${itemId}`)
            .then(response => {
                setViewRawMaterialItemDetails(response.data.data); // assuming data is inside data
                setModalType("RawMaterial");
                setOpen(true);
            })
            .catch(error => {
                console.error("Error fetching raw materials:", error);
            });
    };

    // For Raw Material View(End)
    // For Checklist View(Start)
    const [viewChecklistItemDetails, setViewChecklistItemDetails] = useState(null);

    const handleModalToggleChecklist = (itemId) => {
        axios.get(`${baseURL}/manage-items/quality/${itemId}`)
            .then(response => {
                setViewChecklistItemDetails(response.data.data); // assuming data is inside data
                setModalType("Checklist");
                setOpen(true);
            })
            .catch(error => {
                console.error("Error fetching raw materials:", error);
            });
    };

    // For Checklist View(End)
    const [selectedRow, setSelectedRow] = useState({});


    const handleModalToggleReceipeNotes = async (item) => {
        try {
            const res = await axios.get(`${baseURL}/item_recipe/${item.sno}`);
            const { receipe_notes, receipe_notes_count } = res.data.data;

            const updatedItem = {
                ...item,
                receipe_notes,
                receipe_notes_count,
            };

            // Update the item in your list (assumes you're storing a list of items)
            setItems((prev) =>
                prev.map((it) =>
                    it.sno === item.sno ? updatedItem : it
                )
            );

            setSelectedRow(updatedItem); // Now modal gets the latest notes
            setModalType("AddReceipeNotes");
            setOpen(true);
        } catch (error) {
            console.error("Failed to fetch recipe notes", error);
        }
    };

    const [itemSno, setItemSno] = useState(null); // Optional: to track which item is editing

    const fetchStagingData = async (sno) => {
        const res = await axios.get(`${baseURL}/manage-items/stagging/${sno}`);
        return res.data.data;
    };

    const handleModalItemStaging = async (item) => {
        try {
            const { item_staggings, item_stagging_count } = await fetchStagingData(item.sno);

            const updatedItem = {
                ...item,
                item_staggings,
                item_stagging_count,
            };

            setItems((prev) =>
                prev.map((it) =>
                    it.sno === item.sno ? updatedItem : it
                )
            );

            setSelectedRow(updatedItem);
            setModalType("ItemStaging");
            setOpen(true);
            setItemSno(item.sno);
        } catch (error) {
            console.error("Failed to fetch item staging", error);
        }
    };

    const handleModalItemStagingView = async (sno) => {
        const data = await fetchStagingData(sno);
        setSelectedRow(data);
        setItemSno(sno);
        setModalType("ItemStagingView");
        setOpen(true);
    };

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10) || 1;
    const [isMaintenance, setIsMaintenance] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;

        const checkMaintenanceStatus = async () => {
            try {
                const response = await axios.get(`${baseURL}/maintenance-mode?branch_id=${branch_id}`);
                const data = response.data.data || [];
                const branchStatus = data.find((item) => item.slug === "manage-items"); // use managebranch slug

                if (isMounted) {
                    setIsMaintenance(branchStatus?.maintenancemode_status === 1);
                }
            } catch (error) {
                console.error("Error checking maintenance mode:", error);
                if (isMounted) setIsMaintenance(false);
            } finally {
                if (isMounted) setLoading(false);
            }
        };

        checkMaintenanceStatus();

        return () => {
            isMounted = false;
        };
    }, [baseURL, branch_id]);



    if (isMaintenance) {
        return (
            <div
                className="d-flex flex-column align-items-center justify-content-center text-center"
                style={{ height: "100vh", width: "100vw" }}
            >
                <h1 className="text-warning mb-3">🚧 Under Maintenance</h1>
                <p className="text-muted fs-5">
                    The <strong>Manage Item </strong> module is currently under maintenance. <br />
                    Please check back later.
                </p>
            </div>
        );
    }

    return (
        <>

            {loading ? (
                <div className="d-flex align-items-center justify-content-between flex-wrap page-titles px-0 py-1 mx-0">
                    <div className='mb-2'>
                        <div className="mb-0 px-0">
                            <h4 style={{ color: '#025d3a' }}><Skeleton width={150} /></h4>
                        </div>
                        <ol className="breadcrumb fs-7">
                            <li className="breadcrumb-item"><Skeleton width={70} /></li>
                            <li className="breadcrumb-item"><Skeleton width={20} /></li>
                            <li className="breadcrumb-item active"><Skeleton width={100} /></li>
                        </ol>
                    </div>
                    <div className='d-flex align-items-center gap-3 flex-wrap mb-2'>
                        <Skeleton width={50} height={50} borderRadius={12} />
                    </div>
                </div>
            ) : (
                <div className="d-flex align-items-center justify-content-between page-titles flex-wrap px-0 py-1 mx-0">
                    <div className='mb-2'>
                        <div className="mb-0 px-0">
                            <h4 style={{ color: '#025d3a' }}>Manage Items</h4>
                        </div>
                        <ol className="breadcrumb fs-7">
                            <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                            <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                            <li className="breadcrumb-item active">Package Management</li>
                        </ol>
                    </div>

                    <div className='d-flex align-items-center gap-3 mb-2'>

                        <Dropdown>
                            <Dropdown.Toggle
                                as="button"
                                variant="primary"
                                className="btn btn-primary text-white btn-sm"
                                id="tp-btn"
                            >
                                <span className='me-2'><i class="fa-solid fa-globe mt-1 fs-3 px-0 py-0"></i></span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item href="#" className='px-0 py-2'>
                                    <span className='fs-7 ms-2 font-w500 text-black'>Malayalam</span>
                                </Dropdown.Item>
                                <Dropdown.Item href="#" className='px-0 py-2'>
                                    <span className='fs-7 ms-2 font-w500 text-black'>English</span>
                                </Dropdown.Item>
                                <Dropdown.Item href="#" className='px-0 py-2'>
                                    <span className='fs-7 ms-2 font-w500 text-black'>Tamil</span>
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>

                    </div>

                    {open && modalType === "AddItem" && (
                        <AddItem show={open} onClose={() => setOpen(false)} onSuccess={() => {
                            fetchData();
                        }} />
                    )}

                    {open && modalType === "AddReceipeNotes" && (
                        <AddReceipeNotes show={open} onClose={() => setOpen(false)} data={selectedRow} onSuccess={() => {
                            fetchData();
                        }} /> // ------------------------------- changes
                    )}

                    {open && modalType === "UpdateRawMaterial" && (
                        <UpdateRawMaterial show={open} onClose={() => setOpen(false)} onSuccess={() => {
                            fetchData();
                        }} />
                    )}

                    {open && modalType === "ItemStaging" && (
                        <AddItemStaging show={open} onClose={() => setOpen(false)} itemSno={itemSno} onSuccess={() => {
                            fetchData();
                        }} />
                    )}

                    {open && modalType === "ItemStagingView" && selectedRow && (
                        <ItemStagingView
                            show={open}
                            onClose={() => setOpen(false)}
                            data={selectedRow}
                        />
                    )}
                </div>
            )}


            <Col xl={12} className='mb-3'>
                <div className="custom-tab-1">
                    <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>

                        {loading ? (
                            <Col xl={12} className='mb-3'>
                                <div className="custom-tab-1">
                                    <Nav as="ul" className="nav-tabs">
                                        {[1, 2, 3, 4].map((_, index) => (
                                            <Nav.Item as="li" key={index}>
                                                <Nav.Link disabled className="d-flex align-items-center">
                                                    {/* Icon */}
                                                    <Skeleton circle width={20} height={20} />

                                                    {/* Label */}
                                                    <div className="ms-2">
                                                        <Skeleton width={80} height={14} />
                                                    </div>

                                                    {/* Badge */}
                                                    <div className="ms-2">
                                                        <Skeleton width={30} height={18} borderRadius={12} />
                                                    </div>
                                                </Nav.Link>
                                            </Nav.Item>
                                        ))}
                                    </Nav>
                                </div>
                            </Col>
                        ) : (
                            <Nav as="ul" className="nav-tabs mb-4">
                                <Nav.Item as="li" >
                                    <Nav.Link eventKey="item_list">
                                        <Link to="/manage-items" className="d-flex align-items-center text-decoration-none">
                                            <i className="fa-solid fa-bowl-rice me-3" />
                                            <label className="fs-6">
                                                Items
                                            </label>
                                            <Badge as="a" href="" bg=" badge-circle" className='badge-outline-danger ms-2 fw-bold fs-8'>
                                                {String(itemCount).padStart(2, '0')}
                                            </Badge>
                                        </Link>
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item as="li" >
                                    <Nav.Link >
                                        <Link to="/item-category" className="d-flex align-items-center text-decoration-none">
                                            <i className="fa-solid fa-kitchen-set me-3" />
                                            <label className="fs-6">
                                                Item Category
                                            </label>
                                            <Badge as="a" href="" bg=" badge-circle" className='badge-outline-danger ms-2 fw-bold fs-8'>
                                                {String(itemcategoryCount).padStart(2, '0')}
                                            </Badge>
                                        </Link>
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item as="li" >
                                    <Nav.Link >
                                        <Link to="/item-sub-category" className="d-flex align-items-center text-decoration-none">
                                            <i className="fa-solid fa-plate-wheat me-3" />
                                            <label className="fs-6">
                                                Item Sub Category
                                            </label>
                                            <Badge as="a" href="" bg=" badge-circle" className='badge-outline-danger ms-2 fw-bold fs-8'>
                                                {String(itemsubcategoryCount).padStart(2, '0')}
                                            </Badge>
                                        </Link>
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item as="li" >
                                    <Nav.Link >
                                        <Link to="/item-schedule" className="d-flex align-items-center text-decoration-none">
                                            <svg className="me-2" width="25px" height="25px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 8V12L14.5 14.5" stroke="#025d3a" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z" stroke="#025d3a" stroke-width="1.5"></path> </g></svg>
                                            <label className="fs-6">
                                                Item Schedule
                                            </label>
                                            <Badge as="a" href="" bg=" badge-circle" className='badge-outline-danger ms-2 fw-bold fs-8'>
                                                {String(itemScheduleCount).padStart(2, '0')}
                                            </Badge>
                                        </Link>
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>
                        )}

                        {loading ? (
                            <div className="table-container">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    {/* Left: Show entries dropdown */}
                                    <div>
                                        <label className="me-2"><Skeleton width={50} height={25} /></label>
                                        <Skeleton width={50} height={25} className="mb-1" />
                                    </div>

                                    {/* Right: Search input */}
                                    <div>
                                        <Skeleton width={150} height={25} className="mb-1" />
                                    </div>
                                </div>

                                <table style={{ borderBottom: '2px solid #ddd' }} id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                    <thead>
                                        <tr>
                                            <th><Skeleton width={100} height={16} /></th>
                                            <th><Skeleton width={100} height={16} /></th>
                                            <th><Skeleton width={100} height={16} /></th>
                                            <th><Skeleton width={100} height={16} /></th>
                                            <th><Skeleton width={100} height={16} /></th>
                                            <th><Skeleton width={100} height={16} /></th>
                                        </tr>
                                    </thead>
                                    <tbody className="text-gray-600 fw-semibold fs-7">
                                        {[...Array(perPage)].map((_, i) => (
                                            <tr key={i}>
                                                <td><Skeleton /></td>
                                                <td><Skeleton /></td>
                                                <td><Skeleton /></td>
                                                <td><Skeleton /></td>
                                                <td><Skeleton /></td>
                                                <td><Skeleton /></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                <div className="d-flex justify-content-between align-items-center mt-3">
                                    {/* Bottom left: Showing x to y of z entries */}
                                    <div>
                                        <Skeleton width={180} height={15} />
                                    </div>

                                    {/* Bottom right: Pagination */}
                                    <nav>
                                        <div className="d-flex gap-2">
                                            {[...Array(4)].map((_, i) => (
                                                <Skeleton key={i} width={40} height={25} borderRadius={5} />
                                            ))}
                                        </div>
                                    </nav>
                                </div>
                            </div>
                        ) : (
                            <Tab.Content className="pt-2">
                                <Tab.Pane eventKey="item_list">
                                    <Row>
                                        <Col xl={12} className='mb-3 d-flex align-items-end justify-content-end gap-3'>

                                            {/* <Link to={"#"} className="btn btn-primary float-end btn-sm" >
                                            <span className='me-2'><i class="fa-solid fa-arrow-down"></i> </span>
                                            <span className=''>Import</span>
                                        </Link> */}

                                            <Link to={"#"} className="btn btn-primary float-end btn-sm" onClick={handleModalToggleAdd}>
                                                <span className='me-2'><i class="fa-solid fa-plus fs-8"></i></span>
                                                <span className=''>Add Item</span>
                                            </Link>
                                        </Col>
                                        <Col xl={12}>
                                            <div className="table-container">

                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                    {/* Left: Show entries dropdown */}
                                                    <div>
                                                        <label className="me-2">Show</label>
                                                        <select
                                                            className="form-select d-inline w-auto"
                                                            style={{ fontSize: '0.85rem', height: '30px' }}
                                                            value={perPage}
                                                            onChange={(e) => {
                                                                setPerPage(Number(e.target.value));
                                                                setPage(1); // Reset to first page
                                                            }}
                                                        >

                                                            <option value={25}>25</option>
                                                            <option value={50}>50</option>
                                                            <option value={100}>100</option>
                                                            <option value={125}>125</option>
                                                        </select>
                                                    </div>

                                                    {/* Right: Search input */}
                                                    <div>
                                                        <input
                                                            type="text"
                                                            style={{ fontSize: '0.85rem', height: '40px' }}
                                                            placeholder="Search..."
                                                            className="form-control"
                                                            value={searchTerm}
                                                            onChange={(e) => {
                                                                setSearchTerm(e.target.value);
                                                                setPage(1); // Reset page on new search
                                                            }}
                                                        />
                                                    </div>
                                                </div>

                                                <table className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable" style={{ borderBottom: '2px solid #ddd', overflowX: 'scroll' }}>

                                                    <thead>
                                                        <tr className=" text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                            <th className='min-w-100px text-start'>Items / Quantity</th>
                                                            <th className='min-w-100px'>Ctgy / Sub Ctgy</th>
                                                            <th className='min-w-50px'>Quantity</th>
                                                            <th className='min-w-80px'>
                                                                <OverlayTrigger
                                                                    trigger={['hover', 'focus']}
                                                                    placement="bottom"
                                                                    overlay={
                                                                        <Tooltip className="toltip-popover">
                                                                            <span className="fs-8 text-white fw-semibold">Average Production Cost</span>
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <label className="">Avg Prod Cost</label>
                                                                </OverlayTrigger>
                                                            </th>
                                                            <th className='min-w-80px text-center'>Raw Material</th>
                                                            <th className='min-w-50px'>Status</th>
                                                            <th className='min-w-100px'>Action</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody className="text-gray-600 fw-semibold fs-7">
                                                        {items.map((item, index) => (
                                                            <tr key={item.sno}>
                                                                <td>
                                                                    <div className="d-flex align-items-center justify-content-start gap-2">
                                                                        <LightGallery
                                                                            onInit={onInit}
                                                                            speed={500}
                                                                            plugins={[lgThumbnail, lgZoom]}
                                                                        >
                                                                            <div data-src={item.item_image || bgimage} className='border rounded px-1 py-0'>
                                                                                <img src={item.item_image || bgimage} alt=" " className='cursor-pointer w-45px h-45px' />
                                                                            </div>
                                                                        </LightGallery>
                                                                        <div>
                                                                            <label className='text-black font-w400 fs-7'>{item.item_name}</label>
                                                                            <label className='text-dark-900 font-w400 fs-7 d-block'>{item.item_name_ta}</label>
                                                                            <div className="d-block">
                                                                                <label className="fs-8 text-dark">{item.catering_corp_unit_slug_name}</label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>

                                                                <td>
                                                                    <label className='text-black font-w400 fs-7'>{item.itemcategory_name}</label>
                                                                    <div className="d-block">
                                                                        <label className="fs-8 text-dark">{item.itemsubcategory_name}</label>
                                                                    </div>
                                                                </td>

                                                                <td>
                                                                    <label className='text-black font-w400 fs-7'>
                                                                        {parseFloat(item.catering_corp_quantity) % 1 === 0
                                                                            ? parseInt(item.catering_corp_quantity)
                                                                            : parseFloat(item.catering_corp_quantity)} {item.catering_corp_unit_slug_name}
                                                                    </label>
                                                                </td>

                                                                <td>
                                                                    <label className='text-black font-w400 fs-7'>
                                                                        <span><i class="fa-solid fa-indian-rupee-sign me-1"></i></span>
                                                                        <span>{new Intl.NumberFormat('en-IN').format(item.cost)}</span>
                                                                    </label>
                                                                </td>

                                                                <td className='text-center'>
                                                                    <Badge bg="info" className='text-white fs-7 rounded-pill'>{item.raw_material_count}</Badge>
                                                                </td>

                                                                <td>
                                                                    {[1, 2, 3].includes(item.sno) ? (
                                                                        <span
                                                                            className="text-danger fw-bold"
                                                                            title="You cannot change status for this specific item"
                                                                            style={{ maxWidth: '150px', display: 'inline-block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                                                                        >
                                                                            You cannot change status for this specific item
                                                                        </span>
                                                                    ) : (
                                                                        <div className="form-check form-switch d-flex align-items-center mb-3">
                                                                            <input
                                                                                className="form-check-input me-2"
                                                                                type="checkbox"
                                                                                role="switch"
                                                                                checked={item.status === 0}
                                                                                onChange={() => handleProductStatusChange(item.sno, item.status)}
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </td>

                                                                <td>
                                                                    <span class="text-end d-flex">

                                                                        <OverlayTrigger
                                                                            trigger={['hover', 'focus']}
                                                                            placement="bottom"
                                                                            overlay={
                                                                                <Tooltip className='toltip-popover'>
                                                                                    <span className='fs-8 text-white fw-semibold'>Needed Material</span>
                                                                                </Tooltip>
                                                                            }
                                                                        >
                                                                            <Button
                                                                                variant="primary tp-btn-light px-2 py-1 me-1"
                                                                                onClick={() => handleModalToggleRawMaterial(item.sno)}
                                                                            >
                                                                                <span>
                                                                                    <i className={`fa-solid fa-cart-plus fs-6 mt-1 ${item.raw_material_count > 0 ? 'text-danger' : ''}`}></i>
                                                                                </span>
                                                                            </Button>
                                                                        </OverlayTrigger>

                                                                        <OverlayTrigger
                                                                            trigger={['hover', 'focus']}
                                                                            placement="bottom"
                                                                            overlay={
                                                                                <Tooltip className="toltip-popover">
                                                                                    <span className="fs-8 text-white fw-semibold">Receipe Notes</span>
                                                                                </Tooltip>
                                                                            }
                                                                        >
                                                                            <Button
                                                                                variant="primary tp-btn-light px-2 py-1 me-1"
                                                                                onClick={() => handleModalToggleReceipeNotes(item)}
                                                                            >
                                                                                <span>
                                                                                    <i
                                                                                        className={`fa-regular fa-file-lines fs-6 mt-1 ${item.receipe_notes_count > 0 ? 'text-danger' : ''
                                                                                            }`}
                                                                                    ></i>
                                                                                </span>
                                                                            </Button>
                                                                        </OverlayTrigger>

                                                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Check List</span></Tooltip>} >
                                                                            <Button variant="primary tp-btn-light px-2 py-1 me-1"
                                                                                // onClick={handleModalToggleChecklist}
                                                                                onClick={() => handleModalToggleChecklist(item.sno)}
                                                                            >
                                                                                <span>
                                                                                    {/* <i class="fa-solid fa-list-check fs-6 mt-1"></i> */}
                                                                                    <i
                                                                                        className={`fa-solid fa-list-check fs-6 mt-1 ${item.item_quality_count > 0 ? 'text-danger' : ''
                                                                                            }`}
                                                                                    ></i>

                                                                                </span>
                                                                            </Button>
                                                                        </OverlayTrigger>

                                                                        {/* <OverlayTrigger
                                                                        trigger={['hover', 'focus']}
                                                                        placement="bottom"
                                                                        overlay={
                                                                            <Tooltip className="toltip-popover">
                                                                                <span className="fs-8 text-white fw-semibold">Item Staging</span>
                                                                            </Tooltip>
                                                                        }
                                                                    >
                                                                        <Button
                                                                            variant="primary tp-btn-light px-2 py-1 me-1"
                                                                            onClick={() => handleModalItemStaging(item)}
                                                                        >
                                                                            <span className="position-relative d-inline-block">
                                                                                <i
                                                                                    className={`fas fa-layer-group fs-6 mt-1 ${item.item_stagging_count > 0 ? 'text-danger' : ''
                                                                                        }`}
                                                                                ></i>
                                                                                {item.item_stagging_count > 0 && (
                                                                                    <span
                                                                                        style={{
                                                                                            position: 'absolute',
                                                                                            top: '-4px',
                                                                                            right: '-4px',
                                                                                            backgroundColor: '#dc3545', // Bootstrap danger red
                                                                                            color: '#fff',
                                                                                            borderRadius: '50%',
                                                                                            fontSize: '0.5rem',
                                                                                            padding: '2px',
                                                                                            width: '14px',
                                                                                            height: '14px',
                                                                                            display: 'flex',
                                                                                            alignItems: 'center',
                                                                                            justifyContent: 'center',
                                                                                            fontWeight: 'bold',
                                                                                        }}
                                                                                    >
                                                                                        ✓
                                                                                    </span>
                                                                                )}
                                                                            </span>
                                                                        </Button>
                                                                    </OverlayTrigger> */}

                                                                        <Dropdown drop=''>
                                                                            <Dropdown.Toggle
                                                                                as="a"
                                                                                className="i-false cursor-pointer"
                                                                            >
                                                                                <Button variant="primary tp-btn-light px-3 py-2">
                                                                                    <span><i class="fa-solid fa-ellipsis-vertical fs-6 mt-1"></i></span>
                                                                                </Button>
                                                                            </Dropdown.Toggle>

                                                                            <Dropdown.Menu>

                                                                                <Dropdown.Item href="view-items" className='px-2 py-1'>
                                                                                    <Link as={Link} to={`/view-items?data=${item.sno}`}>
                                                                                        <div className='d-flex align-items-center'>

                                                                                            <div className="rounded px-1 py-1 text-center bg-transparent me-0">
                                                                                                <span><i class="fa-solid fa-eye fs-5 text-danger"></i></span>
                                                                                            </div>
                                                                                            <div className="ms-1 fs-7">View</div>

                                                                                        </div>
                                                                                    </Link>
                                                                                </Dropdown.Item>

                                                                                <Dropdown.Item className='px-2 py-1'
                                                                                    onClick={() => handleModalToggle_Edit(item)}
                                                                                // onClick={handleModalToggleEdit}
                                                                                >

                                                                                    <div className='d-flex align-items-center'>
                                                                                        <div className="rounded px-1 py-1 text-center bg-transparent me-0">
                                                                                            <span><i class="fa-solid fa-pen-to-square fs-5 text-danger"></i></span>
                                                                                        </div>
                                                                                        <div className="ms-2 fs-7">Edit</div>
                                                                                    </div>
                                                                                </Dropdown.Item>

                                                                            </Dropdown.Menu>
                                                                        </Dropdown>
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>

                                                <div className="d-flex justify-content-between align-items-center mt-3">
                                                    {/* Bottom left: Showing x to y of z entries */}
                                                    <div>
                                                        {items.length > 0 && (
                                                            <span className="text-muted">
                                                                Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + items.length} of {itemCount} entries
                                                            </span>
                                                        )}
                                                    </div>

                                                    {/* Bottom right: Pagination */}
                                                    <nav>
                                                        <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                                            {/* Previous Button */}
                                                            <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>
                                                                    Previous
                                                                </button>
                                                            </li>

                                                            {/* First Page */}
                                                            <li className={`page-item ${page === 1 ? 'active' : ''}`}>
                                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(1)}>
                                                                    1
                                                                </button>
                                                            </li>

                                                            {/* Left Ellipsis */}
                                                            {page > 4 && (
                                                                <li className="page-item disabled">
                                                                    <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                                                </li>
                                                            )}

                                                            {/* Pages Around Current */}
                                                            {Array.from({ length: totalPages }, (_, i) => i + 1)
                                                                .filter(p => p >= page - 1 && p <= page + 1 && p !== 1 && p !== totalPages)
                                                                .map(p => (
                                                                    <li key={p} className={`page-item ${page === p ? 'active' : ''}`}>
                                                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(p)}>
                                                                            {p}
                                                                        </button>
                                                                    </li>
                                                                ))}

                                                            {/* Right Ellipsis */}
                                                            {page < totalPages - 3 && (
                                                                <li className="page-item disabled">
                                                                    <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                                                </li>
                                                            )}

                                                            {/* Last Page */}
                                                            {totalPages > 1 && (
                                                                <li className={`page-item ${page === totalPages ? 'active' : ''}`}>
                                                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(totalPages)}>
                                                                        {totalPages}
                                                                    </button>
                                                                </li>
                                                            )}

                                                            {/* Next Button */}
                                                            <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>
                                                                    Next
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </nav>

                                                </div>

                                                {open && modalType === "EditItem" && (
                                                    <EditItem
                                                        show={open}
                                                        onClose={() => setOpen(false)}
                                                        setItems={selectedItem} onSuccess={() => {
                                                            fetchData();
                                                        }}  // Pass selected item data
                                                    />
                                                )}

                                                {open && modalType === "RawMaterial" && viewRawMaterialItemDetails && (
                                                    <AddRawMaterial
                                                        show={open}
                                                        onClose={() => setOpen(false)}
                                                        data={viewRawMaterialItemDetails} onSuccess={() => {
                                                            fetchData();
                                                        }}
                                                    />
                                                )}

                                                {open && modalType === "Checklist" && viewChecklistItemDetails && (
                                                    <AddChecklist
                                                        show={open}
                                                        onClose={() => setOpen(false)}
                                                        data={viewChecklistItemDetails}
                                                        onSuccess={() => {
                                                            fetchData();
                                                        }}
                                                    />
                                                )}

                                            </div>
                                        </Col>
                                    </Row>
                                </Tab.Pane>

                            </Tab.Content>
                        )}

                    </Tab.Container>
                </div>
            </Col>

        </>
    )


}
export default Items;